module.exports = __webpack_public_path__ + "img/twitter.de7ca5fa.svg";